import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";

function NCBI({ item }) {
  return (
    <div className="tw-px-1 tw-py-px">
      <div>
        {item.clinicalSig ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-32">Cln Signifigance</div>
            <div className="tw-flex-grow">{item.clinicalSig}</div>
          </div>
        ) : null}
        {item.data.CLNACC ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-32">CLNACC</div>
            <div className="tw-flex-grow">{item.data.CLNACC}</div>
          </div>
        ) : null}
        {item.data.REGIONID ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-32">Region Id</div>
            <div className="tw-flex-grow tw-max-w-80 tw-break-words">
              {item.data.REGIONID}
            </div>
          </div>
        ) : null}
        {item.data.clinical_source ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-32">Clinical Source</div>
            <div className="tw-flex-grow">{item.data.clinical_source}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

NCBI.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

NCBI.defaultProps = {};

export default NCBI;
